import { motion } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { FaGithub, FaLink } from 'react-icons/fa';

const Box = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 65vw;
  height: 60vh;
  margin-right: 12rem;
  transition: all 0.2s ease;
  color: ${(props) => props.theme.text};

  @media (max-width: 1100px) {
    width: 85vw;
  }

  @media (max-width: 950px) {
    width: 95vw;
  }

  @media (max-width: 830px) {
    height: 50vh;
  }

  @media (max-width: 600px) {
    width: 120vw;
    margin-right: 5rem;
  }

  @media (max-width: 420px) {
    width: 130vw;
    height: 60vh;
  }
`;

const LinkBtn = styled.footer`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 15%;
  left: 0;
  font-size: calc(2rem + 2vw);
  cursor: pointer;
  z-index: 10;

  h3 {
    font-size: calc(0.9rem + 1vw);
    margin: auto 1rem;
  }
`;

const Link = styled(NavLink)`
  display: flex;
  color: ${(props) => props.theme.text};
  text-decoration: none;
  margin-bottom: 3rem;
`;

const Git = styled(NavLink)`
  display: flex;
  color: ${(props) => props.theme.text};
  text-decoration: none;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  font-size: calc(2rem + 4vw);
  text-shadow: 3px 2px 4px ${(props) => props.theme.body};
  position: absolute;
  bottom: 10%;
  left: 0;
  z-index: 10;
`;

const Laptop = styled.div`
  width: 100%;
  height: 100%;

  .mockup {
    position: absolute;
    right: 3%;
    bottom: 0;
    width: 83%;
    height: 93%;
    z-index: 3;
  }

  @media (max-width: 420px) {
    .mockup {
      width: 88%;
      height: 55%;
    }
  }
`;

const Img = styled.div`
  background-image: ${(props) => `url(${props.img})`};
  position: absolute;
  right: 12.6%;
  bottom: 13.1%;
  width: 63.8%;
  height: 75%;
  background-size: cover;
  background-position: top;
  transition: 5s linear;
  z-index: 5;

  &:hover {
    background-position: bottom;
  }

  @media (max-width: 420px) {
    width: 68%;
    height: 45%;
    bottom: 7%;
    right: 13%;
  }
`;

const Contents = styled.div`
  position: absolute;
  left: 11%;
  width: 85%;
  height: 97%;

  border-top: 2px solid ${(props) => `rgba(${props.theme.textRgba}, 0.4)`};
  border-left: 2px solid ${(props) => `rgba(${props.theme.textRgba}, 0.4)`};
  border-right: 2px solid ${(props) => `rgba(${props.theme.textRgba}, 0.2)`};
  border-bottom: 2px solid ${(props) => `rgba(${props.theme.textRgba}, 0.2)`};
  border-radius: 0 90px 90px 250px;
  backdrop-filter: blur(2px);
  z-index: 1;
  cursor: pointer;
  transition: 0.5s;

  &:hover {
    background: ${(props) => `rgba(${props.theme.bodyRgba}, 0.7)`};
    z-index: 15;
  }

  h3 {
    font-family: 'Syne', sans-serif;
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.4)`};
    position: absolute;
    top: 50%;
    left: 5%;
    font-size: calc(1rem + 3vw);
    transform-origin: 0 0;
    transform: rotate(-90deg);
  }

  @media (max-width: 420px) {
    height: 80%;

    h3 {
      top: 35%;
    }
  }
`;

const Description = styled.h2`
  font-size: calc(1rem + 1.5vw);
  font-family: 'karla', sans-serif;
  font-weight: 500;
  margin: 10% 10% 10% 17%;

  @media (max-width: 420px) {
    margin: 7% 8% 8% 17%;
  }
`;

const Tags = styled.div`
  border-top: 2px solid ${(props) => props.theme.text};
  padding-top: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 80%;
  margin: 0 9%;
`;

const Tag = styled.span`
  margin-right: 1rem;
  font-size: calc(1rem + 1vw);
`;

const Item = {
  hidden: {
    scale: 0
  },
  show: {
    scale: 1,
    transition: {
      type: 'spring',
      duration: 0.5
    }
  }
};

const WorkList = (props) => {
  const {
    id,
    name,
    description,
    tags,
    mockup,
    image,
    demo,
    github
  } = props.data;

  return (
    <Box key={id} variants={Item}>
      <LinkBtn>
        <Link to={{ pathname: `${demo}` }} target="_blank">
          <FaLink />
        </Link>
        <Git to={{ pathname: `${github}` }} target="_blank">
          <FaGithub />
        </Git>
      </LinkBtn>
      <Title>{name}</Title>

      <Laptop>
        <img src={`${mockup}`} alt="Laptop Mockup" className="mockup" />
        <Img img={image} />
      </Laptop>

      <Contents>
        <h3>INFO</h3>
        <Description>{description}</Description>
        <Tags>
          {tags.map((t, id) => {
            return <Tag key={id}>#{t}</Tag>;
          })}
        </Tags>
      </Contents>
    </Box>
  );
};

export default WorkList;
